<template>

    <v-app-bar color="white" light flat class="flex-grow-0" :height="60" elevation="4">

        <!-- Tres bloques: marca a la izquierda, titulo al centro, operador a la
             derecha. Los laterales llevan flex-basis 0 y el centro no crece, asi
             el titulo queda en el centro GEOMETRICO de la barra sin importar
             cuanto midan el logo o el nombre del operador. Con v-spacer no
             alcanzaria: centraria solo si los dos lados midieran igual. -->
        <div class="nav-gestion-lateral d-flex align-center">
            <v-img src="@/assets/Logo-bt-07.png" max-width="140" contain class="flex-grow-0 d-none d-sm-flex" />
        </div>

        <div class="nav-gestion-centro d-flex flex-column justify-center text-center px-2">
            <span class="nav-gestion-titulo font-weight-bold primary--text">MODO GESTIÓN</span>
            <span class="nav-gestion-sub grey--text text--darken-1">
                Solo lectura
                <!-- El numero solo existe con un afiliado elegido: en la pantalla
                     de busqueda el nav se muestra igual, y ahi no hay a quien
                     nombrar. Es el unico dato en pantalla que le dice al operador
                     sobre que afiliado esta parado. -->
                <template v-if="nroafiActivo">
                    · Viendo Nº <strong class="primary--text">{{ nroafiActivo }}</strong>
                </template>
            </span>
        </div>

        <!-- Identidad del operador y fecha del dia. El nav es parte del marco
             permanente del modo gestion: se muestra igual en la pantalla de
             busqueda, cuando todavia no hay ningun afiliado elegido, asi que
             nada de este bloque depende del afiliado. -->
        <div class="nav-gestion-lateral nav-gestion-lateral--derecha d-flex flex-column justify-center text-right">
            <span class="nav-gestion-titulo font-weight-bold primary--text">{{ usuiden }}</span>
            <span class="nav-gestion-sub grey--text text--darken-1">{{ fechaHoy }}</span>
        </div>

    </v-app-bar>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters('gestion', ['usuiden', 'nroafiActivo']),
        /*
            Fecha del dia en formato largo: "Viernes, 18 de septiembre de 2026".
            toLocaleDateString con es-AR devuelve el dia en minuscula, asi que se
            capitaliza la primera letra a mano.

            Es un computed sin dependencias reactivas: se evalua una vez por
            montaje y no se actualiza solo. Alcanza, porque la sesion de operador
            dura 4 horas y el nav se remonta al volver a entrar.
        */
        fechaHoy() {
            const fecha = new Date().toLocaleDateString('es-AR', {
                weekday: 'long',
                day: 'numeric',
                month: 'long',
                year: 'numeric',
            });
            return fecha.charAt(0).toUpperCase() + fecha.slice(1);
        },
    },
}
</script>

<style scoped>
/* Laterales: base 0 y crecimiento parejo, para que el bloque del centro quede
   en el centro geometrico de la barra aunque el logo y el nombre del operador
   midan distinto. min-width: 0 permite que se encojan por debajo de su
   contenido, que es lo que evita el scroll horizontal en pantallas chicas. */
.nav-gestion-lateral {
    flex: 1 1 0;
    min-width: 0;
}

.nav-gestion-lateral--derecha {
    align-items: flex-end;
}

/* El centro no crece ni se encoge: conserva su ancho natural y los laterales
   reparten el resto. */
.nav-gestion-centro {
    flex: 0 0 auto;
}

/* Linea principal (titulo de seccion / nombre del operador). */
.nav-gestion-titulo {
    font-size: 0.8rem;
    line-height: 1.15;
}

/* Linea secundaria (estado / fecha del dia). */
.nav-gestion-sub {
    font-size: 0.72rem;
    line-height: 1.15;
}

/* La fecha larga es lo unico que puede desbordar el lateral derecho: se recorta
   con puntos suspensivos antes que empujar la barra. */
.nav-gestion-lateral--derecha .nav-gestion-titulo,
.nav-gestion-lateral--derecha .nav-gestion-sub {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* En mobile el logo esta oculto (d-none d-sm-flex): se achica la tipografia
   para que el titulo centrado y la fecha convivan sin recortarse. */
@media (max-width: 599px) {
    .nav-gestion-titulo {
        font-size: 0.72rem;
    }

    .nav-gestion-sub {
        font-size: 0.64rem;
    }
}
</style>
